var map = {
	"./10C.svg": 3858,
	"./10D.svg": 7789,
	"./10H.svg": 1337,
	"./10S.svg": 7506,
	"./2C.svg": 7061,
	"./2D.svg": 1786,
	"./2H.svg": 7438,
	"./2S.svg": 1733,
	"./3C.svg": 6322,
	"./3D.svg": 5613,
	"./3H.svg": 1801,
	"./3S.svg": 2178,
	"./4C.svg": 4175,
	"./4D.svg": 6704,
	"./4H.svg": 5764,
	"./4S.svg": 6767,
	"./5C.svg": 6044,
	"./5D.svg": 9939,
	"./5H.svg": 1367,
	"./5S.svg": 4428,
	"./6C.svg": 9833,
	"./6D.svg": 9798,
	"./6H.svg": 7554,
	"./6S.svg": 4009,
	"./7C.svg": 2678,
	"./7D.svg": 2089,
	"./7H.svg": 1629,
	"./7S.svg": 6934,
	"./8C.svg": 1523,
	"./8D.svg": 1340,
	"./8H.svg": 3768,
	"./8S.svg": 6851,
	"./9C.svg": 5152,
	"./9D.svg": 2623,
	"./9H.svg": 4123,
	"./9S.svg": 2560,
	"./AC.svg": 8504,
	"./AD.svg": 7223,
	"./AH.svg": 2755,
	"./AS.svg": 648,
	"./BLUE_BACK.svg": 3322,
	"./JC.svg": 7485,
	"./JD.svg": 8194,
	"./JH.svg": 438,
	"./JS.svg": 7981,
	"./KC.svg": 7290,
	"./KD.svg": 2565,
	"./KH.svg": 7025,
	"./KS.svg": 9322,
	"./QC.svg": 9736,
	"./QD.svg": 2567,
	"./QH.svg": 7491,
	"./QS.svg": 5064,
	"./RED_BACK.svg": 841,
	"./TC.svg": 2559,
	"./TD.svg": 6672,
	"./TH.svg": 1732,
	"./TS.svg": 6556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1704;